import { isAdminAccessExpired, markAdminAccessEnded } from './auth-storage';

export const ADMIN_ACCESS_ENDED_PATH = '/auth/admin-access/ended';

/**
 * 서버가 대리 접속 토큰을 더 받지 않을 때(401) 이 탭을 종료 화면으로 보낸다.
 * 리프레시 토큰이 없어 다시 받을 방법이 없고, 일반 로그아웃 처리를 타면 원래 탭의 로그인까지 지워진다.
 *
 * API 클라이언트가 부르므로 API 모듈을 import 하지 않는다(순환 참조 방지).
 */
export function leaveEndedAdminAccess(): void {
  markAdminAccessEnded(isAdminAccessExpired() ? 'EXPIRED' : 'ENDED_ELSEWHERE');
  window.location.replace(ADMIN_ACCESS_ENDED_PATH);
}
